import styled from "styled-components";
import { maxSize } from "../../Utils/common";

export const ThanksWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    
`;

export const ThanksTitle = styled('div')`

color: #B69A67;

    ${props => maxSize(78, props.styleType, 'margin-top', 32)};
    ${props => maxSize(48, props.styleType, 'font-size', 32)};

`;


export const ThanksText = styled('div')`
text-align: center;
${props => maxSize(680, props.styleType, 'width', 237)};
${props => maxSize(47, props.styleType, 'margin-top', 20)};
${props => maxSize(22, props.styleType, 'font-size', 14)};
${props => maxSize(48, props.styleType, 'line-height', 32)};

`;

export const ThanksButton = styled('div')`
${props => maxSize(259, props.styleType, 'width', 157)};
${props => maxSize(68, props.styleType, 'height', 41)};
${props => maxSize(24, props.styleType, 'line-height', 12)};
${props => maxSize(34, props.styleType, 'border-radius', 34)};
${props => maxSize(props.mt || 47, props.styleType, 'margin-top', props.mmt || 20)};
${props => maxSize(props.mab || 0, props.styleType, 'margin-bottom', props.mmab || 0)};

${props => maxSize(24, props.styleType, 'font-size', 12)};
color: white;
background-color: #B69A67;
display: flex;
justify-content: center;
align-items: center;
& span {
${props => maxSize(16, props.styleType, 'height', 8)};
}
`;

export const Line = styled('div')`
    border-bottom: 1px solid #7B7B7B;
    ${props => maxSize(608, props.styleType, 'width', 279)};
    ${props => maxSize(80, props.styleType, 'margin-top', 32)};
`;

export const SocialMediaText = styled('div')`
${props => maxSize(80, props.styleType, 'margin-top', 32)};
${props => maxSize(18, props.styleType, 'font-size', 12)};
color: #4C4C4C;
`;